export const NAME = 'toast';
export const TOAST_LIFESPAN_SEC = 5;
